export default function setPopupSizes() {
  const popup = document.querySelector("[data-size-popup]");
  const togglers = document.querySelectorAll('[data-action="toggle-popup"]');

  if (popup && togglers.length > 0) {
    togglers.forEach((button) => {
      button.addEventListener("click", () => {
        popup.classList.toggle("-open");
      });
    });
  }

  if (window.language === "pt-BR") return;

  const sizeGroups = document.querySelectorAll('[data-size-conversion="true"]');
  if (sizeGroups.length === 0) return;

  sizeGroups.forEach((group) => {
    const dataSource = group.querySelector("[data-size-conversion-source]");
    const tooltip = group.querySelector("[data-size-conversion-tooltip]");
    const mobileCard = group.querySelector("[data-size-conversion-mobile]");
    if (!dataSource) return;

    let parsedData = null;
    try {
      parsedData = JSON.parse(dataSource.textContent.trim());
    } catch (error) {
      return;
    }

    const sizeMap = buildSizeMap(parsedData);
    if (Object.keys(sizeMap).length === 0) return;

    if (window.mobile) {
      if (mobileCard) {
        renderMobileCard(mobileCard);
        syncMobileCardFromSelection(group, mobileCard, sizeMap);

        group.addEventListener("change", (event) => {
          const input = event.target;
          if (!input.matches('input[type="radio"]:checked')) return;

          const trigger = input.nextElementSibling;
          if (!trigger || !trigger.hasAttribute("data-size-br")) return;

          updateMobileCard(mobileCard, trigger, sizeMap);
        });
      }

      return;
    }

    if (!tooltip) return;

    const triggers = group.querySelectorAll("[data-size-br]");

    triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () =>
        showTooltip(trigger, tooltip, sizeMap),
      );
      trigger.addEventListener("mouseleave", () => hideTooltip(tooltip));
      trigger.addEventListener("focusin", () =>
        showTooltip(trigger, tooltip, sizeMap),
      );
      trigger.addEventListener("focusout", () => hideTooltip(tooltip));
    });
  });
}

function renderMobileCard(container) {
  container.innerHTML = `
    <div class="size-conversion-mobile__head">
      <span>BR</span>
      <span>US M/F</span>
      <span>EU</span>
    </div>
    <div class="size-conversion-mobile__value" data-size-conversion-mobile-value>
      <span>-</span>
      <span>-</span>
      <span>-</span>
    </div>
  `;

  container.setAttribute("aria-hidden", "true");
}

function syncMobileCardFromSelection(group, container, sizeMap) {
  const checkedInput = group.querySelector('input[type="radio"]:checked');
  if (!checkedInput) return;

  const checkedTrigger = checkedInput.nextElementSibling;
  if (!checkedTrigger || !checkedTrigger.hasAttribute("data-size-br")) return;

  updateMobileCard(container, checkedTrigger, sizeMap);
}

function updateMobileCard(container, trigger, sizeMap) {
  const brKey = normalizeSizeValue(trigger.getAttribute("data-size-br"));
  const valueContainer = container.querySelector(
    "[data-size-conversion-mobile-value]",
  );

  if (!valueContainer || !brKey || !sizeMap[brKey]) {
    return;
  }

  const { br, us, eu } = sizeMap[brKey];
  valueContainer.innerHTML = `
    <span>${br || "-"}</span>
    <span>${us || "-"}</span>
    <span>${eu || "-"}</span>
  `;

  container.setAttribute("aria-hidden", "false");
}

function buildSizeMap(data) {
  const lookup = {};

  if (Array.isArray(data)) {
    data.forEach((item) => {
      const entry = parseSizeEntry(item);
      if (!entry) return;

      lookup[entry.br] = entry;
    });

    return lookup;
  }

  if (data && typeof data === "object") {
    Object.keys(data).forEach((key) => {
      const entry = parseSizeEntry(data[key], key);
      if (!entry) return;

      lookup[entry.br] = entry;
    });
  }

  return lookup;
}

function parseSizeEntry(item, fallbackBr = "") {
  if (!item || typeof item !== "object") return null;

  const br = normalizeSizeValue(
    item.br || item.BR || item.size_br || item.sizeBR || fallbackBr,
  );

  if (!br) return null;

  return {
    br,
    us: normalizeSizeValue(
      item.us || item.US || item.us_m || item.us_f || item["US M/F"],
    ),
    eu: normalizeSizeValue(item.eu || item.EU),
  };
}

function normalizeSizeValue(value) {
  if (value === undefined || value === null) return "";
  return String(value).trim();
}

function showTooltip(trigger, tooltip, lookup) {
  const brKey = normalizeSizeValue(trigger.getAttribute("data-size-br"));
  if (!brKey || !lookup[brKey]) {
    hideTooltip(tooltip);
    return;
  }

  const { br, us, eu } = lookup[brKey];

  tooltip.innerHTML = `
    <div class="size-conversion-tooltip__head">
      <span>BR</span>
      <span>US M/F</span>
      <span>EU</span>
    </div>
    <div class="size-conversion-tooltip__values">
      <span>${br || "-"}</span>
      <span>${us || "-"}</span>
      <span>${eu || "-"}</span>
    </div>
  `;

  const triggerRect = trigger.getBoundingClientRect();
  const groupRect = tooltip.parentElement.getBoundingClientRect();

  tooltip.classList.add("-visible");
  tooltip.setAttribute("aria-hidden", "false");

  const top = triggerRect.bottom - groupRect.top + 10;
  const left = triggerRect.left + triggerRect.width / 2 - groupRect.left;

  tooltip.style.top = `${top}px`;
  tooltip.style.left = `${left}px`;
}

function hideTooltip(tooltip) {
  tooltip.classList.remove("-visible");
  tooltip.setAttribute("aria-hidden", "true");
}
